import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCountertopOptions = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.countertop.options;

export const options = setCalculationModeCountertopOptions(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_COUNTERTOP_OPTIONS',
  []
);
